import { CURRENCY_SUFFIX } from '../constants';

export function currencyFormat(x, { delimiter=',', suffix=CURRENCY_SUFFIX }={}) {
  if (!(x > 0)) {
    return '0' + suffix;
  }
  const rubles = Math.floor(Math.round(x * 100) / 100);
  let formatted = rubles.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;")
  const kopeks = Math.round(x * 100 - rubles * 100);
  if (kopeks > 0) {
    formatted += delimiter + (kopeks < 10 ? '0' : '') + kopeks;
  }
  return formatted + suffix;
}

export const rangeNum = (size, startAt=0) =>
  [...Array(size).keys()].map(i => i + startAt);

export const pagesShortlist = (curr, last, scope) => !curr ? [1] : (
  // before current page
    curr === 1 ? []
    : curr < 1 + 2 + scope + 1
      ? rangeNum(curr - 1, 1)
      : [1, null, ...rangeNum(scope, curr - scope)]
  //
  ).concat([curr]).concat(
  // after current page
    curr === last ? []
    : curr < last - 2 - scope
      ? [...rangeNum(scope, curr + 1), null, last]
      : rangeNum(last - curr, curr + 1)
  );

export const numberSubjectSuffix = number => {
  if (!(number >= 0)) return '';
  const digits = [...number.toString()].reverse().map(Number);
  if (digits[1] !== 1) {
    if (digits[0] === 1) return "";
    if ([2, 3, 4].indexOf(digits[0]) > -1) return "а";
  }
  return "ов";
}

export const getRandomInt = max =>
  Math.floor(Math.random() * Math.floor(max))
